import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const ImagePage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.Images}
        fetchRecordsUrl={AdminReqUrls.admin__img__mainPage_fetch_recordList}
    />)
});
export default ImagePage;
